import * as WebBrowser from 'expo-web-browser';
import Analytics from '@/utils/analytics';
import Constants from 'expo-constants';
import i18n from '@/utils/i18n';
import React from 'react';
import { CONTAINER_MODAL_ROUTES } from '@/navigators/routes';
import { ContainerModalStackParams } from '@/navigators/types';
import { StackNavigationProp } from '@react-navigation/stack';
import { StyleSheet, Text, View } from 'react-native';
import { TYPOGRAPHY } from '@/styles';
import { useNavigation } from '@react-navigation/native';

export enum LegalLinks {
  PRIVACY = 'https://www.usepepper.com/privacy',
  TERMS = 'https://www.usepepper.com/terms',
}

type Navigation = StackNavigationProp<
  ContainerModalStackParams,
  CONTAINER_MODAL_ROUTES.Licenses
>;

export const Disclosures = () => {
  const { navigate } = useNavigation<Navigation>();

  const linkStyle = [TYPOGRAPHY.xsmall, styles.link];

  return (
    <View style={styles.base}>
      <View style={styles.legalLinks}>
        <Text
          onPress={() => {
            Analytics.track('account.privacy_button.press');
            return WebBrowser.openBrowserAsync(LegalLinks.PRIVACY);
          }}
          style={linkStyle}
        >
          {i18n.t('privacy_policy')}
        </Text>
        <Text style={[TYPOGRAPHY.xsmall, styles.interpunct]}>·</Text>
        <Text
          onPress={() => {
            Analytics.track('account.terms_button.press');
            return WebBrowser.openBrowserAsync(LegalLinks.TERMS);
          }}
          style={linkStyle}
        >
          {i18n.t('terms_of_use')}
        </Text>
        <Text style={styles.interpunct}>·</Text>
        <Text
          onPress={() => {
            navigate(CONTAINER_MODAL_ROUTES.Licenses);
          }}
          style={linkStyle}
        >
          {i18n.t('licenses')}
        </Text>
      </View>
      <Text style={[TYPOGRAPHY.listSmall, styles.versionNumber]}>
        {`v${Constants.expoConfig!.version}`}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  base: {
    alignItems: 'center',
  },
  interpunct: {
    marginHorizontal: 2,
  },
  legalLinks: {
    flexDirection: 'row',
  },
  link: {
    textDecorationLine: 'underline',
  },
  versionNumber: {
    marginTop: 4,
  },
});
